import { Injectable } from '@angular/core';
import { BaseApiService } from '../base-api.service';

@Injectable({
    providedIn: 'root',
})
export class IntegracoesCarsubsService extends BaseApiService {
    constructor() {
        super('integracoes-carsubs');
    }

    getIntegracoesCarsubs() {
        return this.get<any>();
    }
}
